import { render, staticRenderFns } from "./NoteLoading.vue?vue&type=template&id=031c8632&scoped=true&"
import script from "./NoteLoading.vue?vue&type=script&lang=js&"
export * from "./NoteLoading.vue?vue&type=script&lang=js&"
import style0 from "./NoteLoading.vue?vue&type=style&index=0&id=031c8632&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031c8632",
  null
  
)

export default component.exports